import { palette } from '../../constants';
/**
 * Default color palette for charts
 */
export var colorPalette = [
    palette.blue5,
    palette.green6,
    palette.purple4,
    palette.orange5,
    palette.cyan5,
    palette.red6,
    palette.yellow6
];
//# sourceMappingURL=colorPalette.js.map